import type { Translation } from './types';
import { hideArrayProperties } from './types';

export const fr: Translation = hideArrayProperties<Translation>({
  meta: {
    title: 'Aletiq \u2014 Votre IA construit. Aletiq v\u00e9rifie.',
    description:
      'Votre agent IA construit votre site web et le v\u00e9rifie automatiquement avec Aletiq. Double v\u00e9rification pour les applications web g\u00e9n\u00e9r\u00e9es par IA.',
    ogTitle: 'Aletiq \u2014 Votre IA construit. Aletiq v\u00e9rifie.',
    ogDescription: 'Double v\u00e9rification pour les applications web g\u00e9n\u00e9r\u00e9es par IA. Automatique, s\u00e9curis\u00e9, sans effort.',
  },
  nav: {
    home: 'Accueil',
    howItWorks: 'Comment \u00e7a marche',
    useCases: 'Cas d\u2019usage',
    security: 'S\u00e9curit\u00e9',
    pricing: 'Tarifs',
    contact: 'Contact',
    blog: 'Blog',
    cta: 'Commencer gratuitement',
    languageSwitch: 'FR',
  },

  // \u2500\u2500 Hero \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  hero: {
    badge: 'Pour Claude Code, Cursor & Codex via MCP',
    headlineLine1: 'Votre IA construit \u2014',
    headlineLine2: 'Aletiq v\u00e9rifie',
    subheadline:
      'Votre agent IA produit du code plus vite que vous ne pouvez le relire. Aletiq v\u00e9rifie automatiquement, transmet le retour \u00e0 l\u2019agent, et celui-ci corrige imm\u00e9diatement \u2014 vous ne voyez que le r\u00e9sultat final.',
    ctaPrimary: 'Demander un accès anticipé',
    ctaSecondary: 'Comment \u00e7a marche',
    chatFlow: [
      { role: 'user', text: 'Construis-moi une boutique en ligne avec un checkout' },
      { role: 'agent', text: 'Construction de la page produit, du panier et du checkout...' },
      { role: 'agent', text: 'aletiq --verify "teste le checkout" --page /checkout' },
      { role: 'aletiq', text: 'Donn\u00e9es de test pr\u00e9par\u00e9es : produit + adresse renseign\u00e9s', status: 'pass' },
      { role: 'aletiq', text: 'Le bouton de checkout ne r\u00e9pond pas sur mobile', status: 'fail' },
      { role: 'agent', text: 'Bug d\u00e9tect\u00e9 \u2014 correction de la cible tactile...' },
      { role: 'aletiq', text: 'Re-run : checkout termin\u00e9 avec succ\u00e8s', status: 'pass' },
    ],
    demoLines: [
      { type: 'user', text: 'Construis-moi une boutique en ligne avec un checkout' },
      { type: 'blank', text: '' },
      { type: 'agent', text: 'Je construis la page produit, le panier et le checkout.' },
      { type: 'blank', text: '' },
      { type: 'tool-call', text: 'aletiq --verify "teste le checkout" --page /checkout' },
      { type: 'blank', text: '' },
      { type: 'pass', text: 'Donn\u00e9es de test pr\u00e9par\u00e9es : produit + adresse renseign\u00e9s' },
      { type: 'pass', text: 'Navigation : tous les liens fonctionnent' },
      { type: 'fail', text: 'Le bouton de checkout ne r\u00e9pond pas sur mobile' },
      { type: 'blank', text: '' },
      { type: 'agent', text: 'Bug d\u00e9tect\u00e9 \u2014 correction de la cible tactile...' },
      { type: 'blank', text: '' },
      { type: 'tool-call', text: 'aletiq --verify "re-run" (gratuit)' },
      { type: 'blank', text: '' },
      { type: 'pass', text: 'Re-run : checkout termin\u00e9 avec succ\u00e8s' },
      { type: 'pass', text: '3/3 v\u00e9rifications r\u00e9ussies' },
    ],
  },

  // \u2500\u2500 Works With \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  worksWith: {
    subtitle: 'Int\u00e9gration',
    heading: 'Id\u00e9al avec',
    headingHighlight: 'Claude Code',
    description: 'Aletiq utilise MCP \u2014 le standard ouvert pour l\u2019int\u00e9gration d\u2019outils. Claude Code dispose de hooks qui appellent Aletiq automatiquement apr\u00e8s chaque modification. Cursor et Codex fonctionnent via des rules.',
    agents: [
      { name: 'Claude Code', logo: '/images/agents/claude-code.svg' },
      { name: 'Cursor', logo: '/images/agents/cursor.svg' },
      { name: 'Codex', logo: '/images/agents/codex.svg' },
      { name: 'Windsurf', logo: '/images/agents/windsurf.svg' },
      { name: 'Cline', logo: '/images/agents/cline.svg' },
      { name: 'Continue', logo: '/images/agents/continue.svg' },
    ],
  },

  // \u2500\u2500 How It Works (Homepage short version) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  howItWorks: {
    label: 'Comment \u00e7a marche',
    heading: 'Comment \u00e7a',
    headingHighlight: 'fonctionne',
    intro: 'Vous d\u00e9crivez ce que vous voulez. Votre agent IA le construit, le v\u00e9rifie avec Aletiq \u2014 et vous voyez le r\u00e9sultat.',
    steps: [
      {
        number: '01',
        title: 'Vous d\u00e9crivez',
        description: 'Dites \u00e0 votre agent IA ce dont vous avez besoin. Dans vos propres mots, comme une conversation.',
      },
      {
        number: '02',
        title: 'Votre agent construit et v\u00e9rifie',
        description: 'L\u2019agent construit votre fonctionnalit\u00e9, appelle Aletiq, re\u00e7oit le retour \u2014 et corrige les probl\u00e8mes imm\u00e9diatement.',
      },
      {
        number: '03',
        title: 'Vous voyez le r\u00e9sultat',
        description: 'Aletiq renvoie un verdict clair \u00e0 votre agent : r\u00e9ussi, attention requise ou \u00e9chou\u00e9 \u2014 directement dans votre workflow.',
      },
    ],
    linkText: 'En savoir plus',
    linkButton: 'Voir les d\u00e9tails',
  },

  // \u2500\u2500 Why Aletiq (replaces Verification Levels) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  whyAletiq: {
    label: 'Pourquoi Aletiq\u00a0?',
    heading: 'Pourquoi les \u00e9quipes',
    headingHighlight: 'choisissent Aletiq',
    cards: [
      {
        icon: '\uD83D\uDCBB',
        title: 'Tourne sur votre machine',
        description: 'Le runner Aletiq teste directement sur localhost \u2014 z\u00e9ro latence, pas de d\u00e9ploiement n\u00e9cessaire. Votre agent re\u00e7oit un retour en secondes, pas en minutes.',
      },
      {
        icon: '\uD83D\uDD04',
        title: 'Boucle de r\u00e9troaction ferm\u00e9e',
        description: 'Aletiq trouve un bug, votre agent le corrige imm\u00e9diatement \u2014 sans que vous leviez le petit doigt. M\u00eame les donn\u00e9es de test sont pr\u00e9par\u00e9es automatiquement.',
      },
      {
        icon: '\uD83D\uDD12',
        title: 'Vos donn\u00e9es restent locales',
        description: 'Aucun serveur cloud ne voit votre code. Le runner tourne sur votre machine \u2014 ce qui rend Aletiq peu co\u00fbteux pour nous et s\u00e9curis\u00e9 pour vous.',
      },
      {
        icon: '\uD83C\uDFAF',
        title: 'Verdicts clairs',
        description: 'Votre agent appelle aletiq --verify et obtient un r\u00e9sultat sans ambigu\u00eft\u00e9 : r\u00e9ussi ou \u00e9chou\u00e9 \u2014 avec des d\u00e9tails concrets pour la correction.',
      },
    ],
  },

  // \u2500\u2500 Use Cases (Homepage cards) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  useCases: {
    label: 'Cas d\u2019usage',
    heading: 'Ce qu\u2019Aletiq',
    headingHighlight: 'v\u00e9rifie pour vous',
    description: 'Peu importe ce que votre agent IA construit \u2014 Aletiq v\u00e9rifie que \u00e7a fonctionne.',
    viewAllButton: 'Voir tous les sc\u00e9narios',
    cards: [
      {
        slug: 'online-shop',
        icon: '\uD83D\uDED2',
        title: 'Mon checkout fonctionne-t-il\u00a0?',
        description: 'Votre agent a construit une boutique en ligne. Aletiq v\u00e9rifie si les clients peuvent aller du panier jusqu\u2019\u00e0 la commande finalis\u00e9e.',
      },
      {
        slug: 'responsive',
        icon: '\uD83D\uDCF1',
        title: 'Est-ce que \u00e7a rend bien sur mobile\u00a0?',
        description: 'Aletiq ouvre votre site sur diff\u00e9rentes tailles d\u2019\u00e9cran et v\u00e9rifie que tout s\u2019affiche correctement.',
      },
      {
        slug: 'formulaire-contact',
        icon: '\u2709\uFE0F',
        title: 'Le formulaire de contact fonctionne-t-il\u00a0?',
        description: 'Aletiq remplit votre formulaire, l\u2019envoie et v\u00e9rifie que le message est bien re\u00e7u.',
      },
      {
        slug: 'navigation',
        icon: '\uD83E\uDDED',
        title: 'La navigation fonctionne-t-elle\u00a0?',
        description: 'Aletiq clique \u00e0 travers votre menu et v\u00e9rifie que tous les liens m\u00e8nent \u00e0 la bonne destination.',
      },
    ],
  },

  // \u2500\u2500 CTA \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  cta: {
    headline: 'Pr\u00eat\u00a0?',
    headlineHighlight: 'Commencez gratuitement',
    button: 'Commencer gratuitement \u2192',
    card: {
      title: 'Commencez gratuitement',
      description: '50 v\u00e9rifications par mois. Re-runs illimit\u00e9s. Pas de carte bancaire requise.',
      link: 'Voir tous les plans \u2192',
    },
  },

  // \u2500\u2500 Proof Bar \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  proofBar: {
    badges: [
      { icon: '\uD83D\uDD01', text: 'Re-runs toujours gratuits' },
      { icon: '\uD83E\uDDE0', text: 'Effet m\u00e9moire musculaire' },
      { icon: '\uD83E\uDD16', text: 'Z\u00e9ro effort manuel' },
      { icon: '\uD83D\uDCB0', text: 'Jusqu\u2019\u00e0 91\u00a0% moins cher' },
    ],
  },

  // \u2500\u2500 Muscle Memory \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  muscleMemory: {
    label: 'M\u00e9moire musculaire',
    heading: 'Testez une fois,',
    headingHighlight: 'prot\u00e9g\u00e9 pour toujours',
    description:
      'Aletiq m\u00e9morise chaque test. Chaque nouveau build est automatiquement v\u00e9rifi\u00e9 contre tous les tests pr\u00e9c\u00e9dents \u2014 gratuitement. Votre filet de s\u00e9curit\u00e9 grandit avec chaque fonctionnalit\u00e9, sans rien faire.',
    steps: [
      { number: 'Semaine 1', label: 'Formulaire de contact cr\u00e9\u00e9', checks: '4 tests' },
      { number: 'Semaine 2', label: '+ Checkout ajout\u00e9', checks: '11 tests' },
      { number: 'Semaine 4', label: '+ Blog & tableau de bord', checks: '31 tests' },
      { number: 'Semaine 8', label: '+ Paiement & connexion', checks: '47 re-runs gratuits' },
    ],
    caption: 'Les nouveaux tests co\u00fbtent des tokens. Les 47 re-runs : 0\u00a0$.',
  },

  // \u2500\u2500 Token Savings \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  tokenSavings: {
    label: 'Co\u00fbt & efficacit\u00e9',
    heading: '',
    headingHighlight: '91\u00a0% moins cher que les tests manuels',
    description:
      'Votre agent IA produit du code plus vite que vous ne pouvez le relire. Sans Aletiq, vous testez tout manuellement \u2014 ou vous d\u00e9couvrez les bugs en production. Avec Aletiq : automatique, instantan\u00e9, jusqu\u2019\u00e0 91\u00a0% moins cher.',
    comparison: [
      { label: 'Tests manuels', tokens: 'Vous relisez chaque build vous-m\u00eame', bar: 30 },
      { label: 'Sans v\u00e9rification', tokens: 'Bugs en production \u2192 correctif co\u00fbteux', bar: 15 },
      { label: 'Avec Aletiq', tokens: 'Automatique, re-runs gratuits', bar: 100, highlight: true },
    ],
    caption: 'Tourne localement sur votre machine + strat\u00e9gie multi-mod\u00e8les (re-runs avec mod\u00e8le rapide) = jusqu\u2019\u00e0 91\u00a0% moins cher.',
  },

  // \u2500\u2500 Sticky CTA \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  stickyCta: {
    text: 'Re-runs gratuits',
    button: 'Commencer gratuitement',
  },

  // \u2500\u2500 Pricing \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  pricing: {
    label: 'Tarifs',
    title: 'Simple. Transparent. \u00c9quitable.',
    popularBadge: 'Le plus populaire',
    allPlansLabel: 'Inclus dans tous les plans',
    tiers: [
      {
        name: 'Free',
        price: '0\u00a0$',
        period: 'pour toujours',
        verifications: '100 v\u00e9rifications/mois',
        features: [
          'V\u00e9rifications de base (liens, formulaires, mise en page)',
          'Re-runs illimit\u00e9s',
          'Un projet',
          'Support communautaire',
        ],
        cta: 'Commencer gratuitement',
      },
      {
        name: 'Builder',
        price: '39\u00a0$',
        period: '/mois',
        verifications: '500 v\u00e9rifications/mois',
        features: [
          'V\u00e9rifications \u00e9tendues (+ fonctionnalit\u00e9s)',
          'Re-runs illimit\u00e9s',
          "Jusqu'\u00e0 3 projets",
          'Support par e-mail',
          'D\u00e9passement 0,03\u00a0$/v\u00e9rification',
        ],
        cta: 'Commencer avec Builder',
      },
      {
        name: 'Production',
        price: '89\u00a0$',
        period: '/mois',
        verifications: '3\u00a0000 v\u00e9rifications/mois',
        features: [
          'V\u00e9rifications compl\u00e8tes (+ workflows)',
          'Re-runs illimit\u00e9s',
          "Jusqu'\u00e0 10 projets",
          'Acc\u00e8s CI et API',
          'File prioritaire',
          'D\u00e9passement 0,05\u00a0$/v\u00e9rification',
        ],
        cta: 'Commencer avec Production',
        popular: true,
      },
      {
        name: 'Enterprise',
        price: 'Sur mesure',
        period: 'sur demande',
        verifications: 'Quota personnalis\u00e9',
        features: [
          'Projets illimit\u00e9s',
          'SSO / SAML',
          'Espace de travail \u00e9quipe',
          'Merge gating',
          'R\u00e8gles de v\u00e9rification personnalis\u00e9es',
          'Support d\u00e9di\u00e9 + SLA',
        ],
        cta: 'Contacter les ventes',
        contactSales: true,
      },
    ],
    allPlansInclude: [
      'Re-runs illimit\u00e9s et gratuits',
      'Runner local sur votre machine',
      'Int\u00e9gration MCP (Claude Code, Cursor, Codex)',
      'Pr\u00e9paration automatique des donn\u00e9es de test',
    ],
    faq: {
      label: 'FAQ',
      title: 'Questions fr\u00e9quentes',
      items: [
        {
          question: 'Les re-runs sont-ils vraiment gratuits\u00a0?',
          answer: 'Oui. Chaque re-run d\u2019un test existant est enti\u00e8rement gratuit \u2014 peu importe le nombre de fois. Seules les nouvelles v\u00e9rifications sont d\u00e9compt\u00e9es de votre quota.',
        },
        {
          question: 'Qu\u2019est-ce qui compte comme une v\u00e9rification\u00a0?',
          answer: 'Chaque appel aletiq --verify avec un nouveau cas de test compte comme une v\u00e9rification. Les re-runs de tests existants sont gratuits.',
        },
        {
          question: 'Puis-je changer de plan \u00e0 tout moment\u00a0?',
          answer: 'Oui. Vous pouvez changer de plan \u00e0 tout moment. La facturation est ajust\u00e9e au prorata.',
        },
        {
          question: 'Que se passe-t-il quand j\u2019atteins ma limite\u00a0?',
          answer: 'Les re-runs continuent de fonctionner sans limite. Les nouvelles v\u00e9rifications sont mises en file d\u2019attente jusqu\u2019au prochain cycle de facturation.',
        },
        {
          question: 'Quels agents IA fonctionnent avec Aletiq\u00a0?',
          answer: 'Claude Code (via hooks \u2014 int\u00e9gration d\u00e9terministe), Cursor (via rules), Codex (via AGENTS.md), et tout agent compatible MCP.',
        },
        {
          question: 'Faut-il une carte bancaire pour le plan Free\u00a0?',
          answer: 'Non. Le plan Free est gratuit pour toujours, sans carte bancaire. 100 v\u00e9rifications par mois, re-runs illimit\u00e9s.',
        },
      ],
    },
  },

  // \u2500\u2500 How It Works (detail page) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  howItWorksPage: {
    title: 'Comment fonctionne Aletiq',
    subtitle: 'Votre agent IA construit. Aletiq v\u00e9rifie automatiquement. Vous voyez le r\u00e9sultat.',
    heroLabel: 'Comment \u00e7a marche',
    heroTitle: 'Votre agent construit \u2014',
    heroHighlight: 'Aletiq v\u00e9rifie',
    steps: [
      {
        number: '01',
        title: 'Vous d\u00e9crivez ce que vous voulez',
        description: 'Vous parlez \u00e0 votre agent IA \u2014 pas \u00e0 Aletiq directement. Aletiq travaille en arri\u00e8re-plan, invisible pour vous.',
        details: [
          '\u00ab\u00a0Construis-moi une boutique en ligne avec un panier\u00a0\u00bb',
          '\u00ab\u00a0Ajoute un formulaire de contact\u00a0\u00bb',
          '\u00ab\u00a0Cr\u00e9e une landing page pour ma startup\u00a0\u00bb',
        ],
      },
      {
        number: '02',
        title: 'Votre agent construit \u2014 et v\u00e9rifie automatiquement',
        description: 'L\u2019agent int\u00e8gre Aletiq comme outil. Apr\u00e8s chaque fonctionnalit\u00e9, il appelle aletiq --verify. Aletiq teste, pr\u00e9pare les donn\u00e9es de test et donne un retour \u2014 l\u2019agent corrige imm\u00e9diatement.',
        details: [
          'Boucle ferm\u00e9e : v\u00e9rifier \u2192 retour \u2192 corriger \u2192 rev\u00e9rifier',
          'Donn\u00e9es de test pr\u00e9par\u00e9es automatiquement (formulaires, connexions, commandes)',
          'Aucune intervention n\u00e9cessaire \u2014 l\u2019agent et Aletiq g\u00e8rent tout ensemble',
        ],
      },
      {
        number: '03',
        title: 'Vous voyez des r\u00e9sultats clairs',
        description: 'R\u00e9ussi, attention requise ou \u00e9chou\u00e9 \u2014 avec des d\u00e9tails concrets sur ce qui a \u00e9t\u00e9 v\u00e9rifi\u00e9. Votre agent peut r\u00e9agir imm\u00e9diatement.',
        details: [
          'R\u00e9ussi : tout fonctionne comme pr\u00e9vu',
          'Attention : quelque chose semble suspect (ex. : chargement lent)',
          '\u00c9chou\u00e9 : quelque chose ne fonctionne pas \u2014 Aletiq dit \u00e0 votre agent exactement quoi',
        ],
      },
    ],
    resultLabels: {
      pass: 'R\u00e9ussi',
      warn: 'Attention',
      fail: '\u00c9chou\u00e9',
    },
  },

  // \u2500\u2500 Use Cases (detail page) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  useCasesPage: {
    title: 'Ce qu\u2019Aletiq v\u00e9rifie pour vous',
    subtitle: 'Peu importe ce que votre agent IA construit \u2014 Aletiq v\u00e9rifie que \u00e7a fonctionne.',
    heroLabel: 'Cas d\u2019usage',
    heroTitle: 'Peu importe ce que votre agent construit \u2014',
    heroHighlight: 'Aletiq le v\u00e9rifie',
    terminalLabel: 'Exemple en direct',
    terminalTitle: 'Voici \u00e0 quoi ressemble une v\u00e9rification',
    terminalDescription: 'Votre agent appelle aletiq --verify. Aletiq pr\u00e9pare les donn\u00e9es de test, v\u00e9rifie tout et donne un retour concret.',
    scenariosLabel: 'Sc\u00e9narios',
    scenariosTitle: 'Ce que votre agent construit \u2014',
    scenariosHighlight: 'Aletiq le v\u00e9rifie',
    cards: [
      {
        slug: 'online-shop',
        icon: '\uD83D\uDED2',
        title: 'Boutique en ligne',
        whatYouSay: 'Construis-moi une boutique avec un panier',
        whatAletiqChecks: 'Les clients peuvent-ils ajouter des produits et finaliser la commande\u00a0?',
      },
      {
        slug: 'landing-page',
        icon: '\uD83D\uDE80',
        title: 'Landing page',
        whatYouSay: 'Cr\u00e9e une landing page pour ma startup',
        whatAletiqChecks: 'Tous les liens fonctionnent-ils\u00a0? Le rendu est-il correct sur mobile\u00a0?',
      },
      {
        slug: 'systeme-reservation',
        icon: '\uD83D\uDCC5',
        title: 'Syst\u00e8me de r\u00e9servation',
        whatYouSay: 'J\u2019ai besoin d\u2019un outil de prise de rendez-vous',
        whatAletiqChecks: 'Les utilisateurs peuvent-ils s\u00e9lectionner et confirmer des rendez-vous\u00a0?',
      },
      {
        slug: 'dashboard',
        icon: '\uD83D\uDCCA',
        title: 'Tableau de bord',
        whatYouSay: 'Construis-moi un tableau de bord client',
        whatAletiqChecks: 'Les donn\u00e9es se chargent-elles\u00a0? La navigation fonctionne-t-elle\u00a0?',
      },
      {
        slug: 'blog',
        icon: '\uD83D\uDCDD',
        title: 'Blog',
        whatYouSay: 'Cr\u00e9e un blog avec des commentaires',
        whatAletiqChecks: 'Les visiteurs peuvent-ils lire les articles et laisser des commentaires\u00a0?',
      },
      {
        slug: 'espace-membres',
        icon: '\uD83D\uDD10',
        title: 'Espace membres',
        whatYouSay: 'Construis un espace de connexion pour mes clients',
        whatAletiqChecks: 'L\u2019inscription, la connexion et la r\u00e9initialisation du mot de passe fonctionnent-elles\u00a0?',
      },
    ],
  },

  // \u2500\u2500 Security Page (replaces Architecture) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  securityPage: {
    title: 'S\u00e9curit\u00e9 & confidentialit\u00e9',
    subtitle: 'Vos donn\u00e9es restent chez vous. Toujours.',
    heroLabel: 'S\u00e9curit\u00e9',
    heroTitle: 'Vos donn\u00e9es restent',
    heroHighlight: 'chez vous. Toujours.',
    architectureLabel: 'Architecture',
    architectureTitle: 'Tout tourne sur votre machine',
    architectureDescription: 'Le runner Aletiq tourne localement sur votre machine. Votre code, vos donn\u00e9es et vos tests ne quittent jamais votre r\u00e9seau. Seules des statistiques d\u2019utilisation anonymis\u00e9es atteignent nos serveurs.',
    points: [
      {
        icon: '\uD83C\uDFE0',
        title: 'Vos donn\u00e9es restent chez vous',
        description: 'Tous les tests tournent sur votre machine. Votre code et vos donn\u00e9es ne quittent jamais votre r\u00e9seau.',
      },
      {
        icon: '\uD83D\uDC41\uFE0F',
        title: 'Nous ne voyons pas votre code',
        description: 'Seuls les r\u00e9sultats de tests et les observations sont analys\u00e9s. Votre code source reste priv\u00e9.',
      },
      {
        icon: '\uD83E\uDD16',
        title: 'Votre agent, votre contr\u00f4le',
        description: 'Aletiq ne fait que ce que votre agent demande. Aucune action autonome, aucun acc\u00e8s cach\u00e9.',
      },
      {
        icon: '\uD83D\uDD12',
        title: 'Communication chiffr\u00e9e',
        description: 'Toutes les connexions sont chiffr\u00e9es. Vos donn\u00e9es sont aussi s\u00fbres en transit qu\u2019au repos.',
      },
    ],
  },

  // \u2500\u2500 Contact \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  contact: {
    title: 'Contact',
    subtitle: '\u00c9crivez-nous \u2014 nous vous r\u00e9pondrons rapidement',
    nameLabel: 'Nom',
    emailLabel: 'E-mail',
    companyLabel: 'Entreprise',
    messageLabel: 'Message',
    submitButton: 'Envoyer le message',
    salesHeading: 'Des questions sur Premium ou Team\u00a0?',
    validation: {
      nameMin: 'Le nom doit comporter au moins 2 caract\u00e8res',
      emailInvalid: 'Veuillez saisir une adresse e-mail valide',
      messageMin: 'Le message doit comporter au moins 10 caract\u00e8res',
    },
    status: {
      success: 'Votre message a \u00e9t\u00e9 envoy\u00e9. Nous vous r\u00e9pondrons bient\u00f4t\u00a0!',
      error: 'Une erreur s\u2019est produite. Veuillez r\u00e9essayer plus tard.',
    },
  },
  earlyAccess: {
    title: 'Demander un accès anticipé',
    subtitle: 'Aletiq est en accès anticipé. Nous intégrons les partenaires de conception manuellement pour nous assurer que le produit s’adapte à votre façon de travailler.',
    badge: 'Accès anticipé',
    intro: 'Dites-nous ce que vous construisez et comment vous le vérifiez aujourd’hui. Si cela correspond, nous vous contacterons sous 2 jours ouvrés avec une configuration privée.',
    trustBullets: [
      { icon: '•', text: 'Aucune carte bancaire requise' },
      { icon: '•', text: 'Places limitées — nous intégrons des partenaires de conception' },
      { icon: '•', text: 'Réponse sous 2 jours ouvrés' },
    ],
    form: {
      nameLabel: 'Votre nom',
      emailLabel: 'E-mail professionnel',
      emailHint: 'Utilisez un e-mail professionnel — cela nous aide à prioriser.',
      companyLabel: 'Entreprise',
      stackLabel: 'Stack / framework',
      stackPlaceholder: 'ex. Next.js + Vercel, SvelteKit, Rails',
      goalLabel: 'Que voulez-vous vérifier ?',
      goalPlaceholder: 'Brièvement : quels flux votre agent IA construit-il, et où échoue-t-il actuellement ? (1–2 phrases)',
      githubLabel: 'Identifiant GitHub (facultatif)',
      githubHint: 'Facultatif — nous aide à mieux comprendre votre travail.',
      submitButton: 'Demander l’accès',
      submittingButton: 'Envoi en cours…',
    },
    validation: {
      nameMin: 'Veuillez saisir votre nom',
      emailInvalid: 'Veuillez saisir un e-mail professionnel valide',
      stackMin: 'Veuillez indiquer votre stack',
      goalMin: 'Veuillez décrire ce que vous voulez vérifier (au moins 10 caractères)',
    },
    status: {
      successTitle: 'Reçu — merci !',
      successDetail: 'Nous examinerons votre demande et répondrons sous 2 jours ouvrés. Vérifiez votre boîte de réception (et le dossier spam) pour la confirmation.',
      error: 'Une erreur s’est produite. Veuillez réessayer ou nous écrire à hello@aletiq.ai.',
    },
  },
  thankYou: {
    title: 'Merci — message reçu.',
    subtitle: 'Nous vous répondrons dans 1 à 2 jours ouvrés. Vérifiez aussi vos spams.',
    backHome: "Retour à l’accueil",
  },
  notFound: {
    title: 'Page introuvable',
    description: 'La page que vous recherchez n\u2019existe pas ou a \u00e9t\u00e9 d\u00e9plac\u00e9e.',
    backHome: 'Retour \u00e0 l\u2019accueil',
  },
  footer: {
    copyright: '\u00a9 2026 Aletiq. Tous droits r\u00e9serv\u00e9s.',
    builtBy: 'Con\u00e7u par Denqfabrik',
    privacy: 'Politique de confidentialit\u00e9',
    terms: 'Conditions g\u00e9n\u00e9rales',
    imprint: 'Mentions l\u00e9gales',
  },
  structuredData: {
    description:
      'Aletiq v\u00e9rifie automatiquement que les applications web g\u00e9n\u00e9r\u00e9es par IA fonctionnent correctement. Double v\u00e9rification pour les agents IA \u2014 s\u00e9curis\u00e9, rapide, sans effort.',
    offerDescriptions: [
      'V\u00e9rification qualit\u00e9 automatique pour les sites web g\u00e9n\u00e9r\u00e9s par IA',
      'Double v\u00e9rification : votre agent construit, Aletiq v\u00e9rifie',
      'Tests navigateur r\u00e9els avec des verdicts clairs pour votre agent',
    ],
  },
});
